module.exports = __webpack_public_path__ + "img/timg.49095a8e.jpg";